define('models/base/subscribe',['require','mediator','models/base/sync-collection-model'],function(require) {
    'use strict';

    var mediator = require('mediator'),
        SyncCollectionModel = require('models/base/sync-collection-model');

    /*
        Модель обновляемая по подписке
    */

    var SubscribeModel = SyncCollectionModel.extend({
        action: '', // название действия в формате '<%= контроллер %>.<%= действие %>' располагаются на сервере в app/channelActions
        constructor: function() {
            SyncCollectionModel.apply(this, arguments);

            this.subscribeEvent('signinStatus', this.onSignIn);

            this.onSignIn(!!(mediator.user));
        },
        onSignIn: function(signed) {
            //console.log('onSignIn',  signed);
            if (signed) {
                this.load();
            }
        },
        dispose: function() {
            if (this.disposed) { return; }

            if (mediator.channel) {
                mediator.channel.send(this.action + ':off');
            }
            SyncCollectionModel.prototype.dispose.apply(this, arguments);
        },
        sync: function(method, model, options) {
            var _this = this,
                completeFn,
                action = this.action;

            mediator.channel.send(action, this.urlParams());

            mediator.channel.on(action + ':connect', function() {
                //console.log(action + ':connect', !!(mediator.user));
                _this.onSignIn(!!(mediator.user));
            });

            mediator.channel.on(action, function(err, res) {
                if (err) { options.error(err); }
                if (res) { options.success(res); }
                if (completeFn) { completeFn.apply(_this, arguments); }

            });

            return {
                complete: function(fn) {
                    completeFn = fn;
                },
                abort: function() {
                    mediator.channel.off(action);
                    mediator.channel.off(action + ':connect');
                }
            };
        }
    });

    return SubscribeModel;
});
